$(document).ready(function(){
  $('.expcoll-list .expcoll-item .expcoll-box .expcoll-head').click(function(){
    if($(this).parent('.expcoll-box').hasClass('open')){
      $(this).parent('.expcoll-box').removeClass('open');
      $(this).parent('.expcoll-box').find('.expcoll-details').slideUp(300);
    }
    else {
      $('.expcoll-list .expcoll-item .expcoll-box.open').find('.expcoll-details').slideUp(300);
      $('.expcoll-list .expcoll-item .expcoll-box.open').removeClass('open');
      $(this).parent('.expcoll-box').addClass('open');
      $(this).parent('.expcoll-box').find('.expcoll-details').slideDown(300);
    }
  });
});